import { fromLatLng, GeocodeOptions, OutputFormat, setDefaults } from 'react-geocode';
// @ts-ignore
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { Logger } from '../core/logger/Logger';

const geocodeOptions: GeocodeOptions = {
  key: process.env.REACT_APP_GOOGLE_MAPS_PUBLIC_KEY ?? '',
  language: 'de',
  region: 'at',
  outputFormat: OutputFormat.JSON
};

setDefaults(geocodeOptions);

const geocodeLocation = async (latitude: number, longitude: number): Promise<any> => {
  const response = await fromLatLng(latitude, longitude);

  if (response && response.results && response.results[0]) {
    return Promise.resolve(response.results[0]);
  }

  return Promise.reject();
};

const geocodeFromAddress = async (addressParts: {
  street?: string;
  number?: string;
  zip?: string;
  city?: string;
  country?: string;
}): Promise<{ latitude: number; longitude: number } | null> => {
  const { street, number, zip, city, country } = addressParts;
  const addressString = [street, number, zip, city, country].filter(Boolean).join(', ');

  if (addressString.trim()) {
    try {
      const results = await geocodeByAddress(addressString);
      if (results && results.length > 0) {
        const latLng = await getLatLng(results[0]);
        return { latitude: latLng.lat, longitude: latLng.lng };
      }
    } catch (error) {
      Logger.warn('Forward geocoding failed for address:', addressString, error);
    }
  }

  return null;
};

export { geocodeLocation, geocodeFromAddress };
